import {
  styled,
  keyframes
} from '../../../shared/theming-sc'

import {
  keyframesFadeIn,
  prefixed
} from '../../../shared/utilities/styleUtils'

import {
  CELL_HEIGHT
} from '../config'

const cellHeight = `${CELL_HEIGHT}px`

const keyframesSlideIn = keyframes`
  from {
    transform: translate3d(0px,150px,0px);
  }
  to {
    transform: translate3d(0px,0px,0px);
  }
`

export const StyledTreeView = styled.ul`
  list-style-type: none;
  margin: 0;
  position: absolute;
  left: 0;
  top: ${cellHeight};
  width: 100%;
  height: calc(100% - ${cellHeight});
  overflow: hidden; /* Overflow is set in TreeView dynamically */
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch; /* Property has known issues, but works here */
  border-top: 1px solid #dddddd;
`

export const StyledNoSearchResults = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: ${cellHeight};
  padding: 22px 20px;
  animation: ${keyframesFadeIn} 0.3s linear;
`

export const StyledNode = styled.li.attrs({
  style: ({width, slot, slotDelta}) => {
    // fastUpwards -> When closing parents with lots of children - steeper curve for less perceived delay before nodes below come back into view
    const fastUpwards = (slotDelta < -9)
    const time = (slotDelta > 9) ? 1.05 : 0.45

    return prefixed({
      width: `${width}px`,
      transform: `translate3d(0px,${slot * CELL_HEIGHT}px,0px)`,
      transition: `transform ${time}s cubic-bezier(${(fastUpwards) ? '0,1,0,1' : '0.5,0.95,0,1'})`
    })
  }
})`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: ${cellHeight};
  animation: ${keyframesFadeIn} 0.35s cubic-bezier(0.1,0,0.6,1);
  animation-fill-mode: both;
`

export const StyledNodeContent = styled.div.attrs({
  style: ({isAnim, delay}) => {
    const slide = keyframesSlideIn
    const fade = keyframesFadeIn
    const del = `${10 + delay * 40}ms`

    return prefixed({
      animation: isAnim ? `${slide} 0.5s cubic-bezier(0.1,0.95,0,1) ${del} both, ${fade} 0.3s cubic-bezier(0.2,0,0.7,1) ${del} both` : ''
    })
  }
})`
  position: absolute;
  left: 0; top: 0;
  width: 100%;
  height: 100%;
  animation: ${keyframesSlideIn} 0.01s ease-out;
  animation-fill-mode: both;
`

export const StyledNodeChildren = styled.ul`
  list-style-type: none;
  position: absolute;
  left: 0; top: 0;
  width: 100%;
  height: 100%;
`
